import { render, staticRenderFns } from "./Correction.vue?vue&type=template&id=4cddfbe4&"
import script from "./Correction.vue?vue&type=script&lang=js&"
export * from "./Correction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports